/** @jsx jsx */
import { Box, CompanyAvatar } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

import { AttachmentLike } from "@/data/attachments";

interface ClientPageLogoProps {
  name: string;
  logo: AttachmentLike;
}

export const ClientPageLogo: FC<ClientPageLogoProps> = ({ logo, name }) => {
  return (
    <Box backgroundColor="n0" borderRadius="md" sx={{ p: [2, null, null, "xxs"] }}>
      <CompanyAvatar size={["xl", null, null, "xxl"]} img={logo.publicUrl ?? undefined} name={name} />
    </Box>
  );
};
